export default function IframeFormResizer() {
  window.addEventListener("message", (event) => {
    const { iframeHeight } = event.data || {};

    if (!iframeHeight) return;

    const wrappers = document.querySelectorAll<HTMLDivElement>(".js-iframe-resizer");

    wrappers.forEach((wrapper) => {
      const iframe = wrapper.querySelector("iframe");
      const padding = 20;

      if (!iframe) return;
      iframe.style.height = `${iframeHeight + padding}px`;
      wrapper.style.height = `${iframeHeight + padding}px`;
    });
  });
}
